// `email`/`name` must match backend/src/config/appraiser.config.ts — the backend only
// authorizes that exact email to respond to appraisal requests.
export const appraiserConfig = {
    email: 'anthony@hyperionclaims.com',
    name: 'Hyperion Claims Group',
    websiteUrl: 'https://hyperionclaims.com/',
    calendlyEmbedUrl: 'https://calendly.com/oricchioanthony/appr-pa-onboard-meeting',
    appraisalOutcomes: [
        { value: 'accepted', label: 'Accept for appraisal' },
        { value: 'not_ready', label: 'Not ready for appraisal' },
        { value: 'litigation', label: 'Recommend litigation' },
        { value: 'settlement', label: 'Recommend settlement' },
    ],
    serviceAreaStates: [
        'CT', 'NY', 'OH', 'PA', 'DE', 'MD', 'DC', 'VA', 'NC', 'SC', 'TN', 'KY', 'OR', 'GA', 'MO',
    ],
} as const;
